function removeHiFromShopifyAccount() {
    const account = document.querySelector('shopify-account');

    if (!account?.shadowRoot) {
        return false;
    }

    let changed = false;

    const heading = account.shadowRoot.querySelector('#dialog-heading');

    if (heading) {
        const text = heading.textContent.trim();

        if (/^Hi,\s*/i.test(text)) {
            heading.textContent = text.replace(/^Hi,\s*/i, '');
            changed = true;
        }
    }

    const email = account.shadowRoot.querySelector('.account__email');

    if (email) {
        email.remove();
        changed = true;
    }

    return changed;
}

function initShopifyAccountCustomizations() {
    const account = document.querySelector('shopify-account');

    if (!account) {
        return;
    }

    // Intentar varias veces hasta que Shopify haya creado el Shadow DOM
    let attempts = 0;

    const interval = setInterval(() => {
        attempts++;

        const done = removeHiFromShopifyAccount();

        const currentAccount = document.querySelector('shopify-account');

        if (currentAccount?.shadowRoot) {
            const observer = new MutationObserver(() => {
                removeHiFromShopifyAccount();
            });

            observer.observe(currentAccount.shadowRoot, {
                childList: true,
                subtree: true,
                characterData: true
            });

            clearInterval(interval);
        }

        // No estar intentando indefinidamente
        if (done || attempts >= 50) {
            clearInterval(interval);
        }
    }, 200);
}

document.addEventListener('DOMContentLoaded', () => {
    initShopifyAccountCustomizations();
});

(function () {
  function removeGrowaveBrand() {
    const container = document.querySelector('.gw-wl-page-placeholder');

    if (!container || !container.shadowRoot) {
      return;
    }

    const brand = container.shadowRoot.querySelector(
      '.gw-brand.gw-wl-v2__growave-brand'
    );

    if (brand) {
      brand.remove();
    }
  }

  // Al cargar
  removeGrowaveBrand();

  // Growave puede renderizar después
  const observer = new MutationObserver(() => {
    removeGrowaveBrand();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
